import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'

import AttributesInput from './../Filter/attributes-input'
import MerchantsInput from '../Filter/merchants-input'
import FormDatePicker from '../../FormDatePicker'

export default class ItemAttribute extends Component {
  static propTypes = {
    feed: PropTypes.object
  }

  render() {
    return (
      <div>
        <Field name="itemAttributes" component={AttributesInput} />
        <Field name="merchants" component={MerchantsInput} />

        <FormDatePicker
          label="Min Order Date"
          fieldName="minOrderDate"
          isRequired={!this.props.feed.isActive}
          fromDate={new Date('1/1/13')}
          tooltip={'The min order date is inclusive.'}
        />
        {!this.props.feed.isActive && (
          <FormDatePicker
            label="Max Order Date"
            isRequired
            fieldName="maxOrderDate"
            fromDate={this.props.feed.minOrderDate ? new Date(this.props.feed.minOrderDate) : new Date('1/1/13')}
            tooltip={'The max order date is inclusive.'}
          />
        )}
      </div>
    )
  }
}
